// 时间戳转 yyyy-mm-dd格式
export const formatDayTime = (val) => {
	if (val) {
		let date = new Date(val);
		let Y = date.getFullYear();
		let M = date.getMonth() + 1;
		let D = date.getDate();

		if (M < 10) {
			M = '0' + M;
		}
		if (D < 10) {
			D = '0' + D;
		}
		return Y + '-' + M + '-' + D;
	} else {
		return '';
	}
}
export const diffTime =(time)=> {
	var s1 = new Date(time.replace(/-/g, "/")),
	s2 = new Date(),
	runTime = parseInt((s2.getTime() - s1.getTime()) / 1000);
	var year = Math.floor(runTime / 86400 / 365);
	runTime = runTime % (86400 * 365);
	var month = Math.floor(runTime / 86400 / 30);
	runTime = runTime % (86400 * 30);
	var day = Math.floor(runTime / 86400);
	runTime = runTime % 86400;
	var hour = Math.floor(runTime / 3600);
	runTime = runTime % 3600;
	var minute = Math.floor(runTime / 60);
	runTime = runTime % 60;
	var second = runTime;
	// console.log(year+','+month+','+day+','+hour+','+minute+','+second,'哈哈哈')
	if(parseInt(year) >=1){
		// console.log(parseInt(year) + '年前')
		return parseInt(year) + '年前'
	}else if (parseInt(month) >=1) {
		// console.log(parseInt(month) + '个月前')
		return parseInt(month) + '个月前'
	} else if (parseInt(day) > 1) {
		// console.log(parseInt(day) + '天前')
		return parseInt(day) + '天前'
	} else if (parseInt(day) === 1) {
		// console.log('昨天')
		return '昨天'
	} else if(parseInt(hour)>=1){
		// console.log(parseInt(hour) +"小时前")
		return parseInt(hour) +"小时前"
	} else if(parseInt(minute)>=1){
		// console.log(parseInt(minute) +"分钟前")
		return parseInt(minute) +"分钟前"
	} else {
		// console.log("刚刚")
		return "刚刚"
	}
}
// export const diffTime =(time)=> {
// 	var dateTimeStamp = new Date(time).getTime()
// 	var minute = 1000 * 60;
// 	var hour = minute * 60;
// 	var day = hour * 24;
// 	var halfamonth = day * 15;
// 	var month = day * 30;
// 	var year=month * 12

// 	var now = new Date().getTime();
// 	var diffValue = now - dateTimeStamp;

// 	var yearc=diffValue/year;
// 	var monthC =diffValue/month;
// 	var weekC =diffValue/(7*day);
// 	var dayC =diffValue/day;
// 	var hourC =diffValue/hour;
// 	var minC =diffValue/minute;
// 	if(parseInt(yearc) >=1){
// 		console.log(parseInt(yearc) + '年前')
// 		return parseInt(yearc) + '年前'
// 	}else if (parseInt(monthC) >=1) {
// 		console.log(parseInt(monthC) + '个月前')
// 		return parseInt(monthC) + '个月前'
// 	} else if (parseInt(dayC) > 1) {
// 		console.log(parseInt(dayC) + '天前')
// 		return parseInt(dayC) + '天前'
// 	} else if (parseInt(dayC) === 1) {
// 		console.log('昨天')
// 		return '昨天'
// 	} else if(parseInt(hourC)>=1){
// 		console.log(parseInt(hourC) +"小时前")
// 		return parseInt(hourC) +"小时前"
// 	} else if(parseInt(minC)>=1){
// 		console.log(parseInt(minC) +"分钟前")
// 		return parseInt(minC) +"分钟前"
// 	} else {
// 		console.log("刚刚")
// 		return "刚刚"
// 	}
// }

